import  React from "react";
import {
    Badge, Button,
    Card, CardBody, CardFooter, CardHeader,
    Col,
    Container,
    Row
} from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import { connect } from "react-redux";

import {
    requestDetailsConsultation,
    requestUnlockConsultation,
} from "../../actions/consultations.action";
import dateFormat from "dateformat";
import {getStatusName, getStatusColor, getChannelName} from "../../utils/tools";
import {Link} from "react-router-dom";

class Details extends React.Component
{

    constructor(props) {
        super(props);
        let uuid = this.props.match.params.id;
        this.props.loadData(uuid);
        this.unlockConsultation = this.unlockConsultation.bind(this);
    }

    unlockConsultation(event) {
        event.preventDefault();
        if (!this.props.consultations.unlocking) {
            let uuid = this.props.match.params.id;
            this.props.unlockConsultation(uuid);
        }
    }

    // TODO: remettre la durée de la consultation quelque part
    render() {
        const data = this.props.consultations.data;
        return (
            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header pt-4">
                    <PageTitle title="Détails" subtitle="Consultations" className="text-sm-left mb-3"/>
                </Row>

                <Row>
                    <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12 pt-4">
                        {this.props.consultations.fetching ? (
                            <div className="flex-center">
                                <div className="text-center d-block">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <Row>
                                    <Col className="col-lg lg-4 mb-4 col-lg-4 mb-4">
                                        <Row>
                                            <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12">
                                                <Card small className="mb-4">
                                                      <div>
                                                        <CardHeader className="border-bottom">
                                                            <Row>
                                                                <Col md="6">
                                                                    <h6 className="m-0">Informations</h6>
                                                                </Col>
                                                                <Col md="6" className="text-right">
                                                                    <Badge pill
                                                                           theme={getStatusColor(data.status)}>
                                                                        {getStatusName(data.status)}
                                                                    </Badge>
                                                                </Col>
                                                            </Row>
                                                        </CardHeader>
                                                        <CardBody>
                                                            <Row className="m-0">
                                                                <Col md="12" className="form-group">
                                                                    <strong className="mb-2 text-muted d-block">
                                                                        Date et heure
                                                                    </strong>
                                                                    <span>
                                                                    {data.start_at && dateFormat(new Date(data.start_at), "dd/mm/yyyy HH:MM")}
                                                                </span>
                                                                </Col>
                                                            </Row>
                                                            <Row className="m-0">
                                                                <Col md="12" className="form-group">
                                                                    <strong className="mb-2 text-muted d-block">
                                                                        Identifiant technique (rendez-vous)
                                                                    </strong>
                                                                    <span>
                                                                    {data.appointment}
                                                                </span>
                                                                </Col>
                                                            </Row>
                                                            <Row className="m-0">
                                                                <Col md="12" className="form-group">
                                                                    <strong className="mb-2 text-muted d-block">
                                                                        Identifiant technique (consultation)
                                                                    </strong>
                                                                    <span>
                                                                    {data.encounter ? data.encounter : '-'}
                                                                    </span>
                                                                </Col>
                                                                <Col md="12">
                                                                    <strong className="mb-2 text-muted d-block">
                                                                        Documents
                                                                    </strong>
                                                                    {(!data.documents || data.documents.length === 0) &&
                                                                        <span>-</span>
                                                                    }
                                                                    <ul className="mb-0">
                                                                        {data.documents && data.documents.map((document) => {
                                                                            if (document === '81222-2') {
                                                                                return (
                                                                                    <li>Report</li>
                                                                                );
                                                                            } else if (document === '57833-6') {
                                                                                return (
                                                                                    <li>Prescription</li>
                                                                                );
                                                                            } else if (document === 'FSE') {
                                                                                return (
                                                                                    <li>FSE</li>
                                                                                );
                                                                            }
                                                                        })}
                                                                    </ul>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                      </div>
                                                    <CardHeader className="card-header-border">
                                                        <h6 className="m-0">Acte</h6>
                                                    </CardHeader>
                                                    <CardBody className="border-bottom">
                                                        <Row className="m-0">
                                                            <Col md="6" className="form-group">
                                                                <strong className="mb-2 text-muted d-block">Nom</strong>
                                                                <span>
                                                                    {data.product && data.product.name}
                                                                </span>
                                                            </Col>
                                                            <Col md="6" className="form-group">
                                                                <strong className="mb-2 text-muted d-block">Canal</strong>
                                                                <span>
                                                                    {data.product && getChannelName(data.product.channel)}
                                                                </span>
                                                            </Col>
                                                            <Col md="6" className="form-group">
                                                                <strong className="mb-2 text-muted d-block">Prix</strong>
                                                                <span>
                                                                    {data.product && data.product.price / 100}&nbsp;€
                                                                </span>
                                                            </Col>
                                                            <Col md="6">
                                                                <strong className="mb-2 text-muted d-block">
                                                                    État du paiement CB
                                                                </strong>
                                                                <span>{this.getPaymentStatusName(data.orderPaymentStatus)}</span>
                                                            </Col>
                                                            <Col md="6" className="form-group">
                                                                <strong className="mb-2 text-muted d-block">Durée estimée</strong>
                                                                <span>
                                                                    {data.product && data.product.duration} minutes
                                                                </span>
                                                            </Col>
                                                            <Col md="6" className="form-group">
                                                                <strong className="mb-2 text-muted d-block">Durée réelle</strong>
                                                                <span>
                                                                    {data.length || '-'} minutes
                                                                </span>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                    <CardFooter>
                                                            <Row className="m-0">
                                                                <Col md="12">
                                                                    <Button
                                                                        className="block-center"
                                                                        disabled={
                                                                            data.orderPaymentStatus === 'paid'
                                                                            || this.props.consultations.unlocking
                                                                        }
                                                                        onClick={this.unlockConsultation}
                                                                    >
                                                                        Débloquer les documents
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                    </CardFooter>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col className="col-lg lg-8 mb-8 col-lg-8 mb-8">
                                        <div>
                                            <Row className="pb-4">
                                                <Col md="6">
                                                    <Card small className="user-informations">
                                                        <CardHeader className="border-bottom">
                                                            <Row className="m-0">
                                                                <Col md="5">
                                                                    <h6 className="m-0">Praticien</h6>
                                                                </Col>
                                                                <Col md="7" className="text-right">
                                                                    {data.practitioner &&
                                                                        <Link
                                                                            to={`/praticiens/${data.practitioner.uuid}/profil/connect`}>
                                                                            Accéder à la fiche
                                                                        </Link>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </CardHeader>
                                                        <CardBody>
                                                            <Row className="m-0">
                                                                <Col md="6" className="form-group">
                                                                    <strong className="mb-2 text-muted d-block">Prénom</strong>
                                                                    <span>
                                                                {data.practitioner && data.practitioner.firstname}
                                                            </span>
                                                                </Col>
                                                                <Col md="6" className="form-group">
                                                                    <strong className="mb-2 text-muted d-block">Nom</strong>
                                                                    <span>
                                                                {data.practitioner && data.practitioner.lastname}
                                                            </span>
                                                                </Col>
                                                                <Col md="12" className="form-group">
                                                                    <strong className="mb-2 text-muted d-block">Identifiant technique</strong>
                                                                    <span>
                                                                {data.practitioner && data.practitioner.uuid}
                                                            </span>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col md="6">
                                                    <Card small className="user-informations">
                                                        <CardHeader className="border-bottom">
                                                            <Row className="m-0">
                                                                <Col md="5">
                                                                    <h6 className="m-0">Patient {!data.patient && 'anonyme'}</h6>
                                                                </Col>
                                                                <Col md="7" className="text-right">
                                                                    {data.patient &&
                                                                        <Link
                                                                            to={`/patients/${data.patient.uuid}/profil`}>
                                                                            Accéder à la fiche
                                                                        </Link>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </CardHeader>
                                                        <CardBody>
                                                            {data.patient ?
                                                                <Row className="m-0">
                                                                    <Col md="6" className="form-group">
                                                                        <strong
                                                                            className="mb-2 text-muted d-block">Prénom</strong>
                                                                        <span>
                                                                    {data.patient && data.patient.firstname}
                                                                </span>
                                                                    </Col>
                                                                    <Col md="6" className="form-group">
                                                                        <strong
                                                                            className="mb-2 text-muted d-block">Nom</strong>
                                                                        <span>
                                                                    {data.patient && data.patient.lastname}
                                                                </span>
                                                                    </Col>
                                                                    <Col md="12" className="form-group">
                                                                        <strong className="mb-2 text-muted d-block">Identifiant
                                                                            technique</strong>
                                                                        <span>
                                                                    {data.patient && data.patient.uuid}
                                                                </span>
                                                                    </Col>
                                                                </Row>
                                                                :
                                                                <Row className="m-0">
                                                                    <Col md="6" className="form-group">
                                                                        <strong className="mb-2 text-muted d-block">
                                                                            Email
                                                                        </strong>
                                                                        <span>{data.email}</span>
                                                                    </Col>
                                                                </Row>
                                                            }
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            {data.events ?
                                                <Row className="pb-4">
                                                    <Col md="12">
                                                        <Card small className="user-activity mb-4">
                                                            <CardHeader className="border-bottom">
                                                                <h6 className="m-0">Évènements</h6>
                                                            </CardHeader>
                                                            <CardBody className="p-0">
                                                                {data.events && data.events.map((event, key) => {
                                                                    return (
                                                                        <div
                                                                            key={key}
                                                                            className="user-activity__item pr-3 py-3">
                                                                            <div
                                                                                className="user-activity__item__icon">
                                                                                {this.getIcon(event.type)}
                                                                            </div>
                                                                            <div
                                                                                className="user-activity__item__content">
                                                                                <span
                                                                                    className="text-light">{dateFormat(new Date(event.recorded), "dd/mm/yyyy HH:MM:ss")}</span>
                                                                                <p>
                                                                                    {this.getMessage(event.type)}
                                                                                    {event.user_agent && (
                                                                                        <small><br/>{event.user_agent}
                                                                                        </small>)}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                                :
                                                <Row>
                                                    <Col className="col-lg lg-12 mb-12 col-lg-12">
                                                        <Card small className="user-activity mb-4">
                                                            <CardHeader className="border-bottom">
                                                                <h6 className="m-0">La consultation n'a pas
                                                                    débuté</h6>
                                                            </CardHeader>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }

    getPaymentStatusColor(status) {

        switch (status) {
            case 'paid':
                return 'success';
            case 'refused':
                return 'danger';
            case 'need_3ds':
                return 'warning'
            case 'not_paid':
            case undefined:
            default:
                return 'info';
        }
    }

    getPaymentStatusName(status) {
        switch(status) {
            case 'paid':
                return 'Payé';
            case 'refused':
                return 'Paiement refusé';
            case 'authorized':
                return 'Autorisé';
            case 'not_paid':
            case undefined:
                return 'En attente';
            case 'need_3ds':
                return 'En attente 3DS';
            default:
                return status;
        }
    }

    getIcon(type) {
        switch (type) {
            case 'create':
                return <i className="material-icons">add</i>;
            case 'authorize':
                return <i className="material-icons">check</i>;
            case 'patient-join':
                return <i className="material-icons">person_add</i>;
            case 'practitioner-join':
                return <i className="material-icons">person_add</i>;
            case 'practitioner-connect':
                return <i className="material-icons">play_arrow</i>;
            case 'patient-connect':
                return <i className="material-icons">play_arrow</i>;
            case 'terminate':
                return <i className="material-icons">stop</i>;
            case 'patient-disconnect':
                return <i className="material-icons">close</i>;
            case 'practitioner-disconnect':
                return <i className="material-icons">close</i>;
            default:
                return type;
        }
    }

    getMessage(type) {
        switch (type) {
            case 'create':
                return 'Création de la consultation';
            case 'authorize':
                return 'Autorisation de la consultation';
            case 'patient-join':
                return 'Le(La) patient(e) a rejoint la consultation';
            case 'practitioner-join':
                return 'Le(La) praticien(ne) a rejoint la consultation';
            case 'practitioner-connect':
                return 'Le(La) praticien(ne) a commencé la consultation';
            case 'patient-connect':
                return 'Le(La) patient(e) a commencé la consultation';
            case 'terminate':
                return 'La consultation est terminée';
            case 'patient-disconnect':
                return 'Le(La) patient(e) s\'est déconnecté(e)';
            case 'practitioner-disconnect':
                return 'Le(La) praticien(ne) s\'est déconnecté(e)';
            default:
                return type;
        }
    }
}



function mapStateToProps(state)
{
    return {
        consultations: state['consultations'],
    };
}

const mapDispatchToProps = dispatch => ({
    loadData: (e) => dispatch(requestDetailsConsultation(e)),
    unlockConsultation: (e) => dispatch(requestUnlockConsultation(e)),
});

export default connect (
    mapStateToProps,
    mapDispatchToProps
)(Details);



// WEBPACK FOOTER //
// ./src/views/Consultations/Details.js